import { useTranslation } from 'react-i18next';

interface DayStat {
  date: string;
  wordCount: number;
}

interface WordCountAveragesProps {
  data: DayStat[]; // full 365-day array, oldest first
}

export function WordCountAverages({ data }: WordCountAveragesProps) {
  const { t } = useTranslation();

  function avg(days: number) {
    const slice = data.slice(-days);
    const writingDays = slice.filter((d) => d.wordCount > 0).length;
    if (writingDays === 0) return 0;
    return Math.round(slice.reduce((sum, d) => sum + d.wordCount, 0) / writingDays);
  }

  const stats = [
    { key: 'today.wordCountLast12Months', value: avg(365) },
    { key: 'today.wordCountLastMonth', value: avg(30) },
    { key: 'today.wordCountLastWeek', value: avg(7) },
  ];

  return (
    <div className="flex gap-8">
      {stats.map(({ key, value }) => (
        <div key={key} className="flex flex-col gap-0.5">
          <span className="text-xl font-semibold text-ink tabular-nums">{value}</span>
          <span className="text-xs text-ink-400">{t(key)}</span>
        </div>
      ))}
    </div>
  );
}
